var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-wrapper',{staticClass:"c-Image",attrs:{"tag":_vm.tag}},[_c('img',{attrs:{"srcset":_vm.formatedSrcset,"src":_vm.src,"sizes":_vm.formatedSizes,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }